import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";
import { Track } from "../../types";
import DocumentsTab from ".";

function DocumentsMobileTab({
  open,
  onClose,
  track,
}: Readonly<{
  open: boolean;
  onClose: () => void;
  track: Track;
}>) {
  return (
    <FullPageModal isOpen={open} onClose={onClose} title="Documents">
      <DocumentsTab track={track} />
    </FullPageModal>
  );
}

export default DocumentsMobileTab;
